import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import clsx from "clsx";
import { memo, useCallback } from "react";

const FlightSearchTabs = memo(({ activeTab, setActiveTab }) => {
  const t = useTranslationDetector();

  const handleTabClick = useCallback(
    (tabId) => {
      setActiveTab(tabId);
    },
    [setActiveTab],
  );

  return (
    <div className="flight-search-tabs-container rounded-xl border border-white bg-white/60 p-[6px] shadow-[0_8px_42px_0_rgba(0,0,0,0.10)] backdrop-blur-xl md:border-0 md:bg-white/0 md:p-0 md:shadow-none md:backdrop-blur-none">
      <div className="relative flex justify-between gap-0 md:inline-flex md:w-auto md:justify-start md:gap-4 rtl:flex-row-reverse">
        {/* Mobile sliding background */}
        <span
          className={clsx(
            "bg-primary flight-search-tabs-mobile-background absolute top-0 left-0 h-full w-1/3 rounded-md transition-all duration-500 ease-in-out md:hidden",
            activeTab === 0 &&
              "flight-search-tabs-mobile-background-one-way left-0",
            activeTab === 1 &&
              "flight-search-tabs-mobile-background-round-trip left-1/3",
            activeTab === 2 &&
              "flight-search-tabs-mobile-background-multi-city left-2/3",
          )}
        />

        {/* One Way */}
        <button
          className={clsx(
            "flight-search-tabs relative inline-flex w-1/3 cursor-pointer items-center justify-center gap-2 rounded-md py-2 text-center transition-all duration-200 ease-in-out md:w-auto md:justify-start md:py-0 md:text-left",
            activeTab === 0 && "md:text-foreground text-white",
          )}
          onClick={() => handleTabClick(0)}
        >
          <span
            className={clsx(
              "relative hidden h-6 w-6 rounded-full border transition-all duration-200 ease-in-out md:block",
              activeTab === 0
                ? "bg-primary border-primary"
                : "border-primary-weak bg-white",
            )}
          >
            <span
              className={clsx(
                "absolute top-1/2 left-1/2 h-0 w-0 origin-center -translate-x-1/2 -translate-y-1/2 rounded-full bg-white transition-all duration-200 ease-in-out",
                activeTab === 0 && "h-2 w-2",
              )}
            />
          </span>
          <span className="text-sm font-medium">{t("flight.oneWay")}</span>
        </button>

        {/* Round Trip */}
        <button
          className={clsx(
            "flight-search-tabs relative inline-flex w-1/3 cursor-pointer items-center justify-center gap-2 rounded-md py-2 text-center transition-all duration-200 ease-in-out md:w-auto md:justify-start md:py-0 md:text-left",
            activeTab === 1 && "md:text-foreground text-white",
          )}
          onClick={() => handleTabClick(1)}
        >
          <span
            className={clsx(
              "relative hidden h-6 w-6 rounded-full border transition-all duration-200 ease-in-out md:block",
              activeTab === 1
                ? "bg-primary border-primary"
                : "border-primary-weak bg-white",
            )}
          >
            <span
              className={clsx(
                "absolute top-1/2 left-1/2 h-0 w-0 origin-center -translate-x-1/2 -translate-y-1/2 rounded-full bg-white transition-all duration-200 ease-in-out",
                activeTab === 1 && "h-2 w-2",
              )}
            />
          </span>
          <span className="text-sm font-medium">{t("flight.roundTrip")}</span>
        </button>

        {/* Multi City */}
        <button
          className={clsx(
            "flight-search-tabs-multi-city flight-search-tabs multi-city-tab relative inline-flex w-1/3 cursor-pointer items-center justify-center gap-2 rounded-md py-2 text-center transition-all duration-200 ease-in-out md:w-auto md:justify-start md:py-0 md:text-left",
            activeTab === 2 && "md:text-foreground text-white",
          )}
          onClick={() => handleTabClick(2)}
        >
          <span
            className={clsx(
              "relative hidden h-6 w-6 rounded-full border transition-all duration-200 ease-in-out md:block",
              activeTab === 2
                ? "bg-primary border-primary"
                : "border-primary-weak bg-white",
            )}
          >
            <span
              className={clsx(
                "absolute top-1/2 left-1/2 h-0 w-0 origin-center -translate-x-1/2 -translate-y-1/2 rounded-full bg-white transition-all duration-200 ease-in-out",
                activeTab === 2 && "h-2 w-2",
              )}
            />
          </span>
          <span className="text-sm font-medium">{t("flight.multiCity")}</span>
        </button>
      </div>
    </div>
  );
});

FlightSearchTabs.displayName = "FlightSearchTabs";

export default FlightSearchTabs;
